/*global dataLayer*/

function toNumber(val) {
    var n = Number(String(val || '0').replace(/[^\d.]/g, ''));
    return Number.isFinite(n) ? n : 0;
}

function ga4Push(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
}

function buildDonationItem(opts) {
    var value = toNumber(opts.value);
    return {
        item_id: String(opts.item_id || 'DONATION'),
        item_name: String(opts.item_name || 'Donation'),
        item_brand: 'MedicAlert',
        item_category: 'Donation',
        item_category2: String(opts.donation_type || ''), // monthly | one_time
        price: value,
        quantity: 1
    };
}

// Use this after SFCC confirms donation added to cart
window.mafTrackDonationAddToCart = function mafTrackDonationAddToCart(opts) {
    var value = toNumber(opts.value);
    var donationType = opts.donation_type || 'one_time';

    var item = buildDonationItem({
        item_id: opts.item_id,
        item_name: opts.item_name,
        donation_type: donationType,
        value: value
    });

    ga4Push('add_to_cart', {
        donation_only: true,
        donation_flow: 'modal',
        donation_type: donationType,
        ecommerce: {
            currency: opts.currency || 'USD',
            value: value,
            items: [item]
        }
    });
};

// Use this when the user actually reaches checkout (payment UI shown)
window.mafTrackDonationBeginCheckout = function mafTrackDonationBeginCheckout(opts) {
    var value = toNumber(opts.value);
    var donationType = opts.donation_type || 'one_time';

    var item = buildDonationItem({
        item_id: opts.item_id,
        item_name: opts.item_name,
        donation_type: donationType,
        value: value
    });

    ga4Push('begin_checkout', {
        donation_only: true,
        donation_flow: 'modal',
        donation_type: donationType,
        ecommerce: {
            currency: opts.currency || 'USD',
            value: value,
            items: [item]
        }
    });
};


// Use this after SFCC confirms order success (must include transaction_id)
window.mafTrackDonationPurchase = function mafTrackDonationPurchase(opts) {
    var value = toNumber(opts.value);
    var orderId = String(opts.transaction_id || '');

    // hard dedupe protection (prevents double purchase events)
    window.__mafDonationPurchaseSent = window.__mafDonationPurchaseSent || {};
    if (orderId && window.__mafDonationPurchaseSent[orderId]) return;
    if (orderId) window.__mafDonationPurchaseSent[orderId] = true;

    var donationType = opts.donation_type || 'one_time';

    var item = buildDonationItem({
        item_id: opts.item_id,
        item_name: opts.item_name,
        donation_type: donationType,
        value: value
    });

    ga4Push('purchase', {
        donation_only: true,
        donation_flow: 'modal',
        donation_type: donationType,
        ecommerce: {
            transaction_id: orderId,
            currency: opts.currency || 'USD',
            value: value,
            items: [item]
        }
    });
};
